import { getCookie, getCountryCodeAndLanguage, getWuPrepaidLink, screenResolution } from '../services/utility.service.js'
import { handleListItemClick } from '../services/ding-top-up.js'
import getAccountNbrName from './get-accountnbr-name.js'
/**
 * set the fullName of the user
 * @param {string} firstName first name of user
 * @param {string} lastName last name of user
 * @return fullname
 */
const setFullName = (
  firstName,
  lastName
) => {
  let fullName = `${firstName} ${lastName ? lastName : ``}`
  fullName = fullName.toLowerCase().replace(/\b[a-z]/g, (letter) => letter.toUpperCase())
  if (
    (window.matchMedia(`(min-width: 992px) and (max-width: 1145px)`).matches) && fullName.length > 10
  ) {
    fullName = `${fullName.substring(0, 10)}...`
  } else if (
    (window.matchMedia(`(min-width: 1145px`).matches) && fullName.length > 20
  ) {
    fullName = `${fullName.substring(0, 20)}...`
  }
  return fullName
}

/**
 * change the href of headers for logged in state
 */
const changeHrefForLoggedInState = () => {
  const navItem = document.querySelectorAll(`a[data-href]`)
  for (
    let element of navItem
  ) {
    element.setAttribute(`href`, element.getAttribute(`data-href`))
  }
}

const toggleHideShowMenuItems = () => {
  const disableMenuItem = document.querySelectorAll(`li[disable-menu-item="1"]`)
  const {accountNumber} = getAccountNbrName()
  for (let icount of disableMenuItem) {
    (accountNumber) ? icount.classList?.remove('d-none') : icount.classList?.add('d-none')
  }
  const navItemUnverified = document.querySelectorAll(`a[data-href-unverified]`)
  if(disableMenuItem.length > 0 && navItemUnverified.length > 0) {
    menuHideShow(disableMenuItem)
  }
}

/**
 * Function for show and hide menu according to user behavior
 */
const menuHideShow = (disableMenuItem) => {
  const {accountNumber} = getAccountNbrName()
  const isLoggedIn = !!accountNumber
  disableMenuItem?.forEach(item => {
    if(!isLoggedIn) {
      item.classList.add('d-none')
      item.classList.remove('d-L-inline', 'd-XL-inline', 'd-block')
    } else {
      (screenResolution() && (item.classList.contains('d-L-inline') || item.classList.contains('d-XL-inline'))) && item.classList.add('d-none')
    }
  })
}

const logoutMenuCleanupEnabled = () => {
  if((window?.pageData?.env.includes('mywu') || window.pageData?.env.includes('blog'))) return false
  const country = (getCookie("WUCountryCookie_") || '').toUpperCase()
  return window?.pageData?.LOGOUT_MENU_CLEANUP_ENABLED_COUNTRIES.indexOf(country) !== -1
}

/**
 * set header logo link
 * @param {HTMLElement} navItemLink dom element
 */
const setHeaderLogoLink = (
  navItemLink
) => {
  let hrefLogo = navItemLink && navItemLink.getAttribute(`href`)
  if (
    hrefLogo
  ) {
    hrefLogo = hrefLogo.replace(`home.html`, `web/send-money/start`)
    navItemLink.setAttribute(`href`, hrefLogo)

  }
}

/**
 * set profile link
 * @param {HTMLElement} navItemLinkForProfile dom element
 */
const setProfileIconLink = (
  navItemLinkForProfile
) => {
  const {
    countryCode,
    langCode
  } = getCountryCodeAndLanguage()
  if (
    navItemLinkForProfile
  ) {
    navItemLinkForProfile.href = `/${countryCode}/${langCode}/account/app/profile`
  }
}

/**
 * set Western Union Prepaid Link in hamburger menu
 * @param {HTMLElement} navItemLinkForWesternUnionPrepaid dom element
 */
const setWuPrepaidLinkInHamburger = (
  navItemLinkForWuPrepaid
) => {
  if (
    navItemLinkForWuPrepaid && sessionStorage.getItem('prepaidToken')
  ) {
    navItemLinkForWuPrepaid.href =  getWuPrepaidLink() ? `${getWuPrepaidLink()}SSO?Token=${sessionStorage.getItem('prepaidToken')}` : `${navItemLinkForWuPrepaid.href}SSO?Token=${sessionStorage.getItem('prepaidToken')}`
  }
}
/**
 * Function to switch rewards and vulcan header based on the URL
 * @returns {void}
 */
const rewardsVulcanHeaderSwitch = () => {
  const rewardsWunav = document.getElementById('rewards-wunav')
  const mainWunav = document.getElementById('main-wunav')

  if (window.location.href.includes("/rewards/")) {
    mainWunav?.remove()
    rewardsWunav?.classList.remove('d-none')
  } else {
    rewardsWunav?.remove()
  }
}

const isMobile = () => window.innerWidth < 1024

const headerListenerAdd = () => {
  const headerHamburgerEl = document.querySelector(".header-hamburger")
  const languageHamburgerEl = document.querySelector(".language-dropdown")
  const dropdownMenuEl = document.querySelector(".header-hamburger__menu")
  const hamburgerButtonDesktopEL =
    headerHamburgerEl &&
    headerHamburgerEl.querySelector(".header-hamburger_desktop__button")
  const hamburgerButtonMobileEL =
    headerHamburgerEl &&
    headerHamburgerEl.querySelector(".header-hamburger_mobile__button")
  const hamburgerBkgEl =
    headerHamburgerEl &&
    headerHamburgerEl.querySelector(".header-hamburger__background")
  const bodyEl = document.body
  let isDrodpownOpen = false;

  [(languageHamburgerEl)].forEach((el) => {
    if (!el) return
    el.addEventListener("focusin", () => {
      el.setAttribute("aria-expanded", true)
    })
    el.addEventListener("blur", () => {
      el.setAttribute("aria-expanded", false)
    })
  })

  const toggleHamburgerMenu = () => {
    if (!isMobile()) return
    if (
      dropdownMenuEl.classList.contains("header-hamburger__menu--translate")
    ) {
      isDrodpownOpen = true
      dropdownMenuEl.classList.remove("header-hamburger__menu--translate")
      dropdownMenuEl.classList.add("header-hamburger__menu--translate-back")
      if (isMobile()) bodyEl.classList.add("overflow-hidden")
      hamburgerButtonMobileEL.classList.remove("icon-D23-Menu-Hamburger")
      hamburgerButtonMobileEL.classList.add(
        "icon-F02-Cross-Remove-Close-Cancel"
      )
      headerHamburgerEl.classList.remove("overflow-hidden")
      hamburgerBkgEl.classList.remove("d-none")
      hamburgerBkgEl.classList.add("d-block")
      hamburgerButtonDesktopEL.setAttribute("aria-expanded", true)
    } else {
      isDrodpownOpen = false
      dropdownMenuEl.classList.remove("header-hamburger__menu--translate-back")
      dropdownMenuEl.classList.add("header-hamburger__menu--translate")
      headerHamburgerEl.classList.add("overflow-hidden")
      if (isMobile()) bodyEl.classList.remove("overflow-hidden")
      hamburgerButtonMobileEL.classList.add("icon-D23-Menu-Hamburger")
      hamburgerButtonMobileEL.classList.remove(
        "icon-F02-Cross-Remove-Close-Cancel"
      )
      hamburgerBkgEl.classList.add("d-none")
      hamburgerBkgEl.classList.remove("d-block")
      hamburgerButtonDesktopEL.setAttribute("aria-expanded", false)
    }
  }

  if(headerHamburgerEl) {
    dropdownMenuEl && headerHamburgerEl.addEventListener("click", toggleHamburgerMenu)
    headerHamburgerEl.addEventListener('mouseover', () => {
      if(isMobile()) hamburgerButtonMobileEL.setAttribute('aria-expanded', true)
      else hamburgerButtonDesktopEL.setAttribute('aria-expanded', true)
    })
    headerHamburgerEl.addEventListener('mouseout', () => {
      if(isMobile()) hamburgerButtonMobileEL.setAttribute('aria-expanded', false)
      else hamburgerButtonDesktopEL.setAttribute('aria-expanded', false)
    })
  }

  window.addEventListener("resize", () => {
    if (
      !isMobile()
    ) {
      bodyEl.classList.remove("overflow-hidden")
    } else if (isDrodpownOpen) {
      bodyEl.classList.add("overflow-hidden")
    }
  })
}
const configureCalcOnLoggedIn = () => {
  const loggedIn = getCookie("loggedIn") || "false"
  const userIdvStatus = getCookie("userIdvStatus")
  const calculator = document.querySelector(".calculator-uv-user")
  const sectionUnv = document.querySelector(".section-uv-user")
  const { countryCode, langCode } = getCountryCodeAndLanguage()
  const navItemUnverified = document.querySelectorAll(`a[data-href-unverified]`)
  window.managePHHomeExperience && window.managePHHomeExperience()
  const btnUserIdv = document.getElementById('btn-userIdv')
  const footerHomeLink = document.querySelector("#footer-home-link")
  const hideCalculator = () => {
    calculator?.classList.remove("d-flex")
    calculator?.classList.add("d-none")
    sectionUnv?.classList.remove("d-none")
    sectionUnv?.classList.add("d-flex")
  }

  if (
    navItemUnverified.length > 0 &&
    loggedIn === "true" &&
    (userIdvStatus === "I" || userIdvStatus === "N")
  ) {
    for (let element of navItemUnverified) {
      element.setAttribute(
        `href`,
        element.getAttribute(`data-href-unverified`)
      )
    }
  }

  if (loggedIn === "true") {
    if (userIdvStatus === "I" || userIdvStatus === "N") {
      btnUserIdv?.setAttribute(
        "href",
        `/${countryCode}/${langCode}/web/user/dashboard`
      )
      footerHomeLink && footerHomeLink.setAttribute(`href`, `/${countryCode}/${langCode}/web/user/dashboard`)
      hideCalculator()
    } else {
      calculator?.classList.remove("d-none")
      calculator?.classList.add("d-flex")
      sectionUnv?.classList.remove("d-flex")
      sectionUnv?.classList.add("d-none")
      footerHomeLink && footerHomeLink.setAttribute(`href`, `/${countryCode}/${langCode}/web/send-money/start`)
    }
  } else {
    hideCalculator()
    btnUserIdv?.setAttribute(
      "href",
      `/${countryCode}/${langCode}/web/user/register`
    )
    footerHomeLink && footerHomeLink.setAttribute(`href`, `/${countryCode}/${langCode}/web/user/register`)
  }
}

/**
 * logged in state management and username  display function
 */
const loginHelper = () => {
  const isEmailVerificationRequired = JSON.parse(window.sessionStorage.getItem(`C1124`))
  const dingmobile = document.getElementById(`ding_topup-nav-item`)
  dingmobile && dingmobile.addEventListener('click', (e) => {
    e.preventDefault()
    handleListItemClick(e)
  })
  const { accountNumber, userFirstName = 'Hello', userLastName = 'User' } = getAccountNbrName()
  if (
    accountNumber && !isEmailVerificationRequired
  ) {
    const firstName = decodeURIComponent(encodeURIComponent(userFirstName))
    const lastName = decodeURIComponent(encodeURIComponent(userLastName))
    if (
      firstName
    ) {
      const loginNavItem = document.getElementById(`login-nav-item`)
      const mobileLogInRegisterSection = document.getElementById(`mobileLogInRegisterSection`)
      const mobileLoggedInSection = document.getElementById(`mobileLoggedInSection`)
      const navItemLink = document.querySelector(`.wu-header__logo-container .nav-item__link`) || document.querySelector(`.wu-logo`)
      const profileName = document.getElementById(`profileName`)
      const profileNameMobile = document.getElementById(`profileNameMobile`)
      const signUpNavItem = document.getElementById(`sign-up-nav-item`)
      const userLoggedInNavItem = document.getElementById(`user-logged-in-nav-item`)
      const wuUserIconNavItem = document.getElementById(`wu-user-icon-nav-item`)
      const profileIconeLink = document.querySelector('#wu-user-icon-nav-item a')
      const navItemWuPrepaidLink = document.querySelector('a[amplitude-id="menu-prepaid-card"]')
      const fullname = setFullName(firstName, lastName)
      changeHrefForLoggedInState()
      setHeaderLogoLink(navItemLink)
      setProfileIconLink(profileIconeLink)
      navItemWuPrepaidLink && setWuPrepaidLinkInHamburger(navItemWuPrepaidLink)
      if(signUpNavItem) {
        signUpNavItem.className = signUpNavItem.className.replace(`d-L-block`, `d-none`)
        signUpNavItem.className = signUpNavItem.className.replace(`d-L-flex`, `d-none`)
      }
      loginNavItem.className = loginNavItem && loginNavItem.className.replace(`d-L-block`, `d-none`)
      loginNavItem.className = loginNavItem && loginNavItem.className.replace(`d-L-flex`, `d-none`)
      mobileLoggedInSection.className = mobileLoggedInSection && mobileLoggedInSection.className.replace(`d-none`, `d-none d-flex`)
      mobileLogInRegisterSection.className = mobileLogInRegisterSection && mobileLogInRegisterSection.className.replace(`d-flex`, `d-none`)
      wuUserIconNavItem.className = wuUserIconNavItem && wuUserIconNavItem.className.replace(`d-none`, `d-none d-L-block`)
      userLoggedInNavItem.className = userLoggedInNavItem && userLoggedInNavItem.className.replace(`d-none`, `d-none d-L-block`)
      if (profileName) {
        profileName.innerHTML = fullname
      }
      if (profileNameMobile) {
        profileNameMobile.innerHTML = fullname
      }
    }
  }
  if(logoutMenuCleanupEnabled()) {
    toggleHideShowMenuItems()
  }
  configureCalcOnLoggedIn()
}

export { setFullName, rewardsVulcanHeaderSwitch, setProfileIconLink, loginHelper, headerListenerAdd }
